//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'product-card-info',
  components: {
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
    'info-video': () => import('./info/media-types/ProductInfoVideo.vue'),
    'info-video-template': () => import('./info/media-types/ProductInfoVideoTemplate.vue'),
    'info-music': () => import('./info/media-types/ProductInfoMusic.vue'),
    'info-sfx': () => import('./info/media-types/ProductInfoSfx.vue'),
    'info-default': () => import('./info/media-types/ProductInfoDefault.vue'),
  },
  props: {
    element: Object,
    showProductIcon: {
      type: Boolean,
      default: true,
    },
    showPro: {
      type: Boolean,
      default: true,
    },
    collectionItemCount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      faMeSubscription,
    };
  },
  computed: {
    isCollection() {
      return _.get(this.element, 'object') === 'collection';
    },
    isSubscription() {
      return _.get(this.element, 'subscription');
    },
    mediaType() {
      if (this.isCollection) {
        return 'collection';
      }
      return _.get(this.element, 'mediaType'); // just need to check like this
    },
    isRequiredVersionName() {
      const versionName = _.get(this.element, 'mediaTypeDetails.softwareRequired.versionName', null);
      const versionNumber = _.get(this.element, 'mediaTypeDetails.softwareRequired.versionNumber', null);
      return !!versionName || !!versionNumber;
    },
    showInfo() {
      // if video_template no ProductIcon, no software required, no Subscrtion, show no Info section
      if (isProductType('video_template', this.mediaType)) {
        if (!this.showProductIcon && !this.isSubscription && !this.isRequiredVersionName) {
          return false;
        }
      } else if (
        isProductType('image', this.mediaType)
        || isProductType('vr', this.mediaType)
        || isProductType('3d', this.mediaType)
      ) {
        if (!this.showProductIcon && !this.isSubscription) {
          return false;
        }
      }
      return true;
    },
    infoComponent() {
      switch (true) {
        case isProductType('video', this.mediaType):
          return 'video';

        case isProductType('video_template', this.mediaType):
          return 'video-template'; // return component name

        case isProductType('music', this.mediaType):
          return 'music';

        case isProductType('sfx', this.mediaType):
          return 'sfx';

        default:
          return 'default';
      }
    },
    aiGeneratorName() {
      const generator = this.element.categories.find(({ type }) => type === 'generator');
      return _.get(generator, 'name');
    },
    showAiGeneratorName() {
      return this.aiGeneratorName && this.mediaType === 'image_prompt';
    },
  },
};
